import React, { useState, useEffect } from "react";
import classes from "./Login.module.css";
import RccgLogo from '../../Assets/rotating-logo.png';
import CalculatorIcon from '../../Assets/cal.png';
import GrowthIcon from '../../Assets/growth.png';
import TeamIcon from '../../Assets/team.png';
import RotatingLogo from '../../Assets/rotating-logo.png';
import { useNavigate, useLocation } from "react-router-dom";
import eye from "../../Assets/eye.svg";
import eyesoff from "../../Assets/eyesoff.svg";
import { Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";
import { BASE_URL } from "../../Components/Styles/API/API";

export default function ResetPassword() {
  const [email, setEmail] = useState("");
   const location = useLocation();
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
    const [showPassword1, setShowPassword1] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);
    
    const [token, setToken] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const togglePasswordVisibility1 = () => {
        setShowPassword1(!showPassword1);
    };

    const togglePasswordVisibility2 = () => {
        setShowPassword2(!showPassword2);
    };


    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const tokens = searchParams.get('token');
        setToken(tokens)
        console.log('Here is your token:', tokens); 
        
        // if (tokens) {
        //     handleForgotPassword(token);
        // }
    }, [location.search]);

    const handleLogin = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${BASE_URL}/reset-password`,
                {
                //    password: oldPassword,
                   password: newPassword,
                   password_confirmation: confirmPassword,
                   token: token
                }
            );
                navigate('/');

        } catch (error) {
            let errorMessage = error.response?.data?.message || 'An error occurred';
            if (error.message === 'Network Error') {
                errorMessage = 'Connection error. Please check your internet connection.';
            }
            Swal.fire({
                icon: 'error',
                title: 'Failed',
                text: JSON.stringify(error.response.data.message),
              });
        } 
        finally {
            setLoading(false);
        }
    }


  return (
    <div className={classes.loginPage}>
      {/* LEFT SIDE (Hides on mobile) */}
      <div className={classes.leftSide}>
        <img src={RccgLogo} alt="Suite" className={classes.rlogo} />
        <h1 className={classes.topHeader}>Smart Accounting for Church Management</h1>
        <p className={classes.subHeader}>
          Streamline your finances with AI-powered tools designed
          specifically for Church Management
        </p>

        <div className={classes.featureBox}>
          <img src={CalculatorIcon} alt="Calculator" />
          <div>
            <p className={classes.cro_pt}>Complete Accounting Suite</p>
            <p className={classes.mind}>Everything you need to manage your finances</p>
          </div>
        </div>

        <div className={classes.featureBox}>
          <img src={GrowthIcon} alt="Growth" />
          <div>
            <p className={classes.cro_pt}>Growth Analytics</p>
            <p className={classes.mind}>Track your business growth with detailed reports</p>
          </div>
        </div>

        <div className={classes.featureBox}>
          <img src={TeamIcon} alt="Team" />
          <div>
            <p className={classes.cro_pt}>Team Collaboration</p>
            <p className={classes.mind}>Work together with your team seamlessly</p>
          </div>
        </div>
      </div>

      {/* RIGHT SIDE LOGIN BOX */}
      <div className={classes.loginBox} >
        <h1 style={{paddingTop: '0.5rem'}} className={classes.signTxt}>Reset your Password</h1>
        <p style={{
          fontSize: 14,
          color: 'black',
          textAlign: 'center',
          marginTop: -20
        }}>The new password must be at least 8 characters.</p>

        <div className={classes.formGroup}>
         
                            <Form.Label  >New Password</Form.Label>
                            <div className={classes.portal}>
                            <input onChange={(e) => setNewPassword(e.target.value)} type={showPassword1 ? 'text' : 'password'} placeholder="Enter your new password"  className={classes.print}  />
                            <button
                                type="button"
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    cursor: 'pointer',
                                    float: 'right',
                                    left: "-30px",
                                    marginTop: '-2px',
                                    position: 'relative',
                                    zIndex: 2
                                }}
                                onClick={togglePasswordVisibility1}
                            >
                                {showPassword1 ? (
                                    <img src={eyesoff} alt="Hide Password" style={{ height: "20px", width: "20px" }} />
                                ) : (
                                  <img src={eye} alt="Hide Password" style={{ height: "20px", width: "20px" }} />
                                    // '👁️'
                                )}
                            </button>
                        </div>
                        <div style={{marginTop: 10}}/>
                            <Form.Label  >Confirm your Password</Form.Label>
                             <div className={classes.portal}>
                            <input onChange={(e) => setConfirmPassword(e.target.value)} type={showPassword2 ? 'text' : 'password'} placeholder="Confirm your new password"  className={classes.print}  />
                            <button
                                type="button"
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    cursor: 'pointer',
                                    float: 'right',
                                    left: "-30px",
                                    marginTop: '-2px',
                                    position: 'relative',
                                    zIndex: 2
                                }}
                                onClick={togglePasswordVisibility2}
                            >
                                {showPassword2 ? (
                                    <img src={eyesoff} alt="Hide Password" style={{ height: "20px", width: "20px" }} />
                                ) : (
                                    <img src={eye} alt="Hide Password" style={{ height: "20px", width: "20px" }} />
                                )}
                            </button>
                        </div>
        </div>

        {/* <div className={classes.formGroup}>
          <label>Password</label>
          <div className={classes.portal}>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
              className={classes.print}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <img
              src={showPassword ? eyesoff : eye}
              alt="Toggle visibility"
              className={classes.eye}
              onClick={() => setShowPassword((prev) => !prev)}
            />
          </div>
        </div> */}

        {/* <div className={classes.options}>
         
  <Form.Check 
    type="switch"
    id="remember-switch"
    label="Remember Me"
    className={classes.rememberMe}
  />

          <span className={classes.forgotPassword}>Forgot Password?</span>
        </div> */}
        {/* <div style={{marginTop: '2rem'}}/> */}
   <Button  onClick={handleLogin} disabled={!newPassword || !confirmPassword || newPassword !== confirmPassword} variant="primary" className={classes.signInBtn}>Reset Password</Button>
      </div>
   {loading && (
  <div className={classes.overlay}>
    <img src={RotatingLogo} alt="Loading..." className={classes.rotatingLogo} />
  </div>
)}
    </div>
  );
}
